<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="details">
        <!-- 微导航 -->
        <div class="wnav">
          <span>测评体系</span> >
          <span>更多测评</span> >
          <span>测评详情</span> >
          <span>{{name}}</span> >
          <span class="gengduo">测评结果</span>
        </div>
        <!-- 身体 -->
        <div class="st" v-for="(list,index) in lists" :key="index">
          <div class="left">
            <ul>
              <li class="active">测评结果</li>
            </ul>
            <div id="container"></div>
            <div class="left-cont">
              <div class="zhdf">综合得分：</div>
              <div class="num">{{list.sum}}</div>
              <div v-html="list.analyze"></div>
            </div>
          </div>
          <div class="right">
            <div class="xgpc">
              <div class="title1">相关评测</div>
              <div
                class="cont"
                @click="gocp(list1)"
                v-for="(list1,index) in list.appraisal_array"
                :key="index"
              >
                <img :src="list1.image" alt />
                <div class="cont-right">
                  <div class="cont-name">{{list1.name}}</div>
                  <div class="cont-price">{{list1.price}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
import { Radar } from "@antv/g2plot";

export default {
  name: "details",
  data() {
    return {
      id: "",
      lists: [],
      name: "",
    };
  },
  created() {
    var id = this.$route.query.id;
    this.id = id;
    var title = this.$route.query.name;

    this.name = title;
  },
  methods: {
    render_aa(data_aa) {
      var data = data_aa;
      const radarPlot = new Radar(document.getElementById("container"), {
        title: {
          visible: false,
          text: "",
        },
        data,
        angleField: "item",
        radiusField: "score",
        seriesField: "user",
        color: ["#7098F3", "#cad4e0"],
        radiusAxis: {
          grid: {
            line: {
              type: "line",
            },
          },
        },
        line: {
          visible: true,
          stlye: {},
        },
        point: {
          visible: true,
          shape: "circle",
        },
        legend: {
          visible: true,
          position: "bottom-center",
        },
      });

      radarPlot.render();
    },
    async appraisal_result() {
      var id = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .appraisal_result({
          uid: id.id,
          id: this.id,
          // id: 592,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.code == 200) {
            this.lists.push(res.data.content);
            res.data.content.my_list.map((item) => {
              item.score = Number(item.score);
            });

            let data_aa = res.data.content.my_list;
            setTimeout(() => {
              this.render_aa(data_aa);
            }, 100);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    gocp(list) {
      // console.log(list)
      this.$router.push({
        path: "/evalu_details",
        query: {
          id: list.id,
        },
      });
    },
  },
  components: {
    Header,
    Footer,
  },
  mounted() {
    this.appraisal_result();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.background .details {
  width: 1200px;
  margin: 0 auto;
}
/* 微导航 */
.background .details .wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.background .details .wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.background .details .st {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.background .details .st .left {
  width: 860px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.background .details .st .left ul {
  display: flex;
  border-bottom: 1px solid #ededed;
}
.background .details .st .left ul li {
  height: 62px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.background .details .st .left ul li.active {
  color: #1775ef;
}
.background .details .st .left .left-cont {
  width: 809px;
  margin-left: 20px;
}
.background .details .st .left .left-cont .zhdf {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
  margin-bottom: 15px;
}
.background .details .st .left .left-cont .num {
  font-size: 32px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
}
.background .details .st .right {
  width: 324px;
  height: 687px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.background .details .st .right .xgpc {
  width: 290px;
  margin: 0 auto;
  margin-top: 20px;
}
.background .details .st .right .xgpc .title1 {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin-bottom: 21px;
}
.background .details .st .right .xgpc .cont {
  margin-bottom: 22px;
  display: flex;
}
.background .details .st .right .xgpc .cont img {
  width: 120px;
  height: 67px;
  margin-right: 6px;
}
.background .details .st .right .xgpc .cont .cont-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.background .details .st .right .xgpc .cont .cont-price {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 67, 67, 1);
  line-height: 18px;
  margin: 9px 0 0 135px;
}
</style>



// WEBPACK FOOTER //
// src/components/cptx/evalu_result.vue